import React from "react";
import styled from "styled-components";
import { ArrowLeftSrc, LogoMinSrc } from "../../../resources/Assets";

export const Header = (props) => {
  const { backUrl } = props;
  return (
    <HeaderDiv>
      <div
        style={{ width: "40px", height: "40px" }}
        // onClick={() => (backUrl ? backUrl : window.history.back())}
        onClick={backUrl && backUrl != "" ? backUrl : () => window.history.back()}
      >
        {backUrl != "none" && <img src={ArrowLeftSrc} />}
      </div>
      <div>
        <img src={LogoMinSrc} />
      </div>
      <div style={{ width: "40px", height: "40px" }}>{/* <img src={ArrowLeft} /> */}</div>
    </HeaderDiv>
  );
};

export const HeaderDiv = styled.div`
  display: flex;
  padding: 0px 16px 8px 16px;
  justify-content: space-between;
  align-items: center;

  color: #333;
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px; /* 125% */
`;
